import type { QueryClient } from "@tanstack/react-query";
import { getToken, readClaims, setToken } from "./token";

// NATIVE-SHELL TOKEN HANDOFF. ANDROID EMBEDS PAGES AS `<path>?t=<token>` AND iOS
// BUILDS `/in-play/<playerId>?t=<token>`; THE ANGULAR `AuthGuard` WRITES ANY `t`
// IT SEES STRAIGHT TO STORAGE BEFORE CHECKING LOGIN. SAME HERE, PLUS ONE THING
// THE ANGULAR APP HAS NO NEED FOR: A HANDOFF FOR A DIFFERENT USER DROPS THE
// QUERY CACHE, SO THE PREVIOUS USER'S PLAYERS ARE NEVER SERVED FROM MEMORY.
export function acceptHandoffToken(searchStr: string, queryClient: QueryClient): void {
  const incoming = new URLSearchParams(searchStr).get("t");
  if (!incoming || incoming === getToken()) return;

  const previousUser = readClaims()?.userId;
  const nextUser = readClaims(incoming)?.userId;

  setToken(incoming);

  if (previousUser !== nextUser) {
    queryClient.clear();
  }
}
